export default __webpack_public_path__ + "static/not_found-8b4ad245fb94d77a1eb6d0240864f878.png";